// TODO: Use enums for the diffrent roles and types

import { Organization } from 'models/organization';
import { User } from 'models/user';

/**
 * DD-3391: the three external user tiers. Mirrored from
 * shared-denthub-code/src/models/external-user-role.ts — the frontend is a view
 * layer, not an auth boundary, so it reads the role rather than importing it.
 */
export const EXTERNAL_USER_ROLES = ['RESTRICTED_EXTERNAL_USER', 'EXTERNAL_TECHNICIAN', 'ELEVATED_EXTERNAL_USER'];

// TODO: Accept the whole user object, makes the code shorter outside
class Permissions {
    private static _instance: Permissions = new Permissions();
    constructor() {
        if (Permissions._instance) {
            throw new Error('Singleton class');
        }
        Permissions._instance = this;
    }

    public static get instance(): Permissions {
        return Permissions._instance;
    }

    isDentist(userType: string): boolean {
        return userType === 'dentist';
    }

    isLabTechnician(userType: string): boolean {
        return userType === 'lab_technician';
    }

    isDentistAdmin(userRole?: string): boolean {
        return userRole === 'DENTIST_ADMIN';
    }

    isClinicAdmin(userRole?: string): boolean {
        return userRole === 'DENTIST_CLINIC_MANAGER';
    }

    isDentistUser(userRole?: string) {
        return userRole === 'DENTIST_USER';
    }

    isWhiteLabeledOrganization(organization?: Organization): boolean {
        return !!organization?.isWhiteLabeled;
    }

    isTechnicianAdmin(userRole?: string): boolean {
        return userRole === 'TECHNICIAN_ADMIN';
    }

    /**
     * DD-3391: true for every external tier, not just the legacy role. Around 50
     * call sites ask this question by this name and mean "is this user external?";
     * narrowing it back to one role would silently hand a restricted or elevated
     * user everything a lab technician sees.
     */
    isExternalTechnician(userRole?: string): boolean {
        return EXTERNAL_USER_ROLES.includes(userRole as string);
    }

    /** Sees the order with customer, patient, dentist and price withheld. */
    isRestrictedExternalUser(userRole?: string): boolean {
        return userRole === 'RESTRICTED_EXTERNAL_USER';
    }

    /** May also do a technician's work on the order: actions, materials, finish, send. */
    isElevatedExternalUser(userRole?: string): boolean {
        return userRole === 'ELEVATED_EXTERNAL_USER';
    }

    /**
     * DD-3589: mirrors `@externalUserGuard(minimumLevel: "ELEVATED")` on the backend's
     * `departments` query, so the UI does not ask for what it will be refused.
     */
    canReadDepartments(userRole?: string): boolean {
        return !this.isExternalTechnician(userRole) || this.isElevatedExternalUser(userRole);
    }

    isInternalTechnician(userRole?: string): boolean {
        return userRole === 'TECHNICIAN_USER' || userRole === 'TECHNICIAN_ADMIN';
    }

    isCarrier(userRole?: string): boolean {
        return userRole === 'CARRIER';
    }
}

export const permissions = Permissions.instance;
